module.exports = __webpack_public_path__ + "search-icon-5b5afaf1.png";